import { ReactPlugin } from "@microsoft/applicationinsights-react-js"
import { IConfig, IConfiguration } from "@microsoft/applicationinsights-web"
import { History } from "history"

export const DUMMY_INSTRUMENTATION_KEY =
    "InstrumentationKey=00000000-0000-0000-0000-000000000000"

export const isAppInsightsEnabled = (
    connectionString: string | null | undefined,
    enabledFlag?: string,
): boolean =>
    Boolean(connectionString?.trim()) && enabledFlag?.trim().toLowerCase() !== "false"

export const createAppInsightsConfig = (
    connectionString: string | null | undefined,
    enabled: boolean,
    browserHistory?: History,
    reactPlugin?: ReactPlugin,
): IConfiguration & IConfig => ({
    connectionString: enabled
        ? connectionString?.trim() || DUMMY_INSTRUMENTATION_KEY
        : DUMMY_INSTRUMENTATION_KEY,
    extensions: reactPlugin ? [reactPlugin] : undefined,
    enableAutoRouteTracking: true,
    autoTrackPageVisitTime: true,
    disableTelemetry: !enabled,
    extensionConfig: {
        AppInsightsCfgSyncPlugin: { blkCdnCfg: true },
        ...(reactPlugin
            ? {
                  [reactPlugin.identifier]: {
                      ...(browserHistory ? { history: browserHistory } : {}),
                  },
              }
            : {}),
    },
})
